import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './redux/store';
import useLocalStorage from './hooks/useLocalStorage';
import Navbar from './Navbar';
import Home from './Home';
import Projects from './Projects';
import ProjectDetail from './ProjectDetail';
import Contact from './Contact';
import NotFound from './NotFound';
import './App.css';

function App() {
  const [theme, setTheme] = useLocalStorage('theme', 'dark');

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  return (
    <Provider store={store}>
      <div className={`app-container ${theme}`}>
        <Router>
          <Navbar theme={theme} toggleTheme={toggleTheme} />
          <div className="content-wrap">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/projects/:id" element={<ProjectDetail />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        </Router>
      </div>
    </Provider>
  );
}

export default App;
